import Component from '@glimmer/component';

import { array } from '@ember/helper';

import and from 'rise-ui/helpers/and.js';
import classMod from 'rise-ui/helpers/class-mod.js';
import isEmpty from 'rise-ui/helpers/is-empty.js';
import not from 'rise-ui/helpers/not.js';

export default class CFieldComponent extends Component {
  <template>
    {{#let
      (array
        (and
          (not (has-block))
          (isEmpty @value)
          (isEmpty @empty)
        ) "--empty"
        (and
          (not (has-block))
          (isEmpty @value)
          (not (isEmpty @empty))
        ) "--empty-alt"
      )
      as | classModifiers |
    }}
    <div class={{classMod "c-field" modifiers=classModifiers}} ...attributes>
      {{#if @label}}
        <span class={{classMod "c-field__label" modifiers=classModifiers}}>
          {{~@label~}}
        </span>
      {{/if}}
      <span class={{classMod "c-field__value" modifiers=classModifiers}}>
        {{~#if (has-block)~}}
          {{yield}}
        {{~else if (isEmpty @value)~}}
          {{@empty}}
        {{~else~}}
          {{@value}}
        {{~/if~}}
      </span>
    </div>
    {{/let}}
  </template>
}
